module.exports = __webpack_public_path__ + "static/media/recenttransac.ad96f6a0.png";